import { useTranslation } from '@/i18n'
import { useAppStore } from '@/store'

/**
 * "Did this answer your question?" assistant bubble + a clearly tappable
 * "Yes, I'm done!" CHOICE chip. Outlined button styling — deliberately NOT
 * the dark sent-message look, so it can't read as something the user
 * already said; it's appended to the thread as a real user message only
 * when clicked. Declining is implicit: the input stays live, so typing a
 * follow-up just continues the conversation.
 */
const FeedbackPromptBubble = () => {
  const { t } = useTranslation('help_agent')
  const acceptHelpFeedbackPrompt = useAppStore((s) => s.acceptHelpFeedbackPrompt)

  return (
    <>
      <div className="flex justify-start">
        <div className="max-w-[85%] rounded-lg bg-gray-100 px-3 py-2 text-sm text-gray-900 dark:bg-dark-accent dark:text-dark-text">
          {t('feedback.did_answer')}
        </div>
      </div>
      <div className="flex justify-end">
        <button
          type="button"
          onClick={() => acceptHelpFeedbackPrompt(t('feedback.done_pill'))}
          className="rounded-full border border-gray-300 bg-white px-4 py-1.5 text-sm text-gray-900 transition-colors hover:border-gray-900 hover:bg-gray-50 dark:border-dark-border dark:bg-dark-card dark:text-dark-text dark:hover:bg-dark-accent"
        >
          {t('feedback.done_pill')}
        </button>
      </div>
    </>
  )
}

export default FeedbackPromptBubble
